// extracted by mini-css-extract-plugin
export default {"middlePaneWrapper":"MilestoneCreateEdit-module__middlePaneWrapper--T05l8","milestonePageDescription":"MilestoneCreateEdit-module__milestonePageDescription--q6Hqk"};